/**
 * Public TrackSolid configuration values
 */
export class TenantSettingsPublicIntegrationsTrackSolidDto {
  baseUrl?: string | null;

  isAccountConfigured?: boolean | null;
  isAppKeyConfigured?: boolean | null;
  isAppSecretConfigured?: boolean | null;
  isPasswordConfigured?: boolean | null;
}
